import React, { createContext, useContext, useEffect, useState } from "react";

// Ребрендинг 2026: светлая кремовая палитра под новый логотип + возможность
// вернуть классическую чёрную. Только клиентская часть приложения.
const STORAGE_KEY = "angiolini_theme";
const ThemeContext = createContext({ theme: "light", setTheme: () => {}, toggleTheme: () => {} });

export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "light" || saved === "dark") return saved;
    } catch { /* приватный режим */ }
    return "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-ang-theme", theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* noop */ }
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "light" ? "#F3E3C8" : "#0A0A0A");
  }, [theme]);

  const toggleTheme = () => setTheme(t => (t === "light" ? "dark" : "light"));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
